import {Navigate, useParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

/**
 * Legacy URL redirects for the Wave 4 page merges (docs/plans/training-admin-overhaul.md):
 * EditCourseClassroom + ViewCourseClassroom merged into the Class Workspace
 * (schedule is now an inline edit modal, not a separate route); EditCourseSession
 * folded into an inline edit on the session record view.
 */
const EditClassroomRedirect = () => {
  const {definitionId, classroomId} = useParams();
  return (
    <Navigate
      to={PathUtility.TrainingCourseClassroomView(
        String(definitionId),
        String(classroomId),
        'roster'
      )}
      replace
    />
  );
};

const EditSessionRedirect = () => {
  const {definitionId, assignmentId, sessionId} = useParams();
  return (
    <Navigate
      to={PathUtility.TrainingCourseSessionView(
        String(definitionId),
        String(assignmentId),
        String(sessionId),
        'overview'
      )}
      replace
    />
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'transient',
  path: PathUtility.TrainingCourseClassroomEdit(':definitionId', ':classroomId'),
  element: <EditClassroomRedirect />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'transient',
  path: PathUtility.TrainingCourseSessionEdit(
    ':definitionId',
    ':assignmentId',
    ':sessionId'
  ),
  element: <EditSessionRedirect />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
